import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { find, forEach, get, map } from 'lodash-es';

import * as statsActions from '../../Services/Stats/actions';

import ExtractBlock from './ExtractBlock';

import './Stats.scss';

class Stats extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { actions } = this.props;

    actions.getAdminConfigRequest();
  }

  convertDate = date => {
    const split = date.split('/');

    return `${split[2]}-${split[1]}-${split[0]}`;
  };

  handleSubmitGetQuotations = idx => values => {
    const {
      actions,
      stats: { config = [] },
    } = this.props;
    const data = {};

    forEach(values, (value, key) => {
      const fieldConf = find(config?.[idx]?.fields, { name: key });

      data[fieldConf ? fieldConf.code : key] = fieldConf?.type === 'date' ? this.convertDate(value) : value;
    });

    actions.exportQuotationsStatsRequest(data);
  };

  render() {
    const {
      stats: { config = [], strings = {} },
      i18n,
    } = this.props;

    const initialValues = map(config, ({ fields }) => {
      const initValues = {};

      forEach(fields, field => {
        initValues[field.name] = field.default;
      });

      return initValues;
    });

    return (
      <div className="coog-app stats">
        <Helmet
          htmlAttributes={{
            class: 'coog',
            lang: i18n.lang,
          }}
        >
          <meta charSet="utf-8" />
          <title>{get(strings, 'title', 'Statistics')}</title>
          <meta name="description" content={get(strings, 'title')} />
          <link rel="canonical" href={get(strings, 'canonical')} />
        </Helmet>
        <h1 className="md-title md-cell md-cell--12 title">{strings.title}</h1>
        {map(config, (cfg, idx) => (
          <ExtractBlock
            key={`extractBlock_${idx}`}
            config={cfg}
            strings={strings}
            locale={i18n.lang}
            initialValues={initialValues[idx]}
            onSubmit={this.handleSubmitGetQuotations(idx)}
          />
        ))}
      </div>
    );
  }
}

Stats.propTypes = {
  strings: PropTypes.shape({
    pageTitle: PropTypes.string,
    canonical: PropTypes.string,
  }),
};

Stats.defaultProps = {
  strings: {
    pageTitle: 'Statistics',
    canonical: 'http://www.coopengo.com/',
  },
};

const mapStateToProps = state => {
  const system = state.get('system').toJS();

  return {
    i18n: system?.i18n ?? {},
    stats: state.get('stats').toJS(),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...statsActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Stats));
